<template>
  <SubSection ref="sub-section" />
</template>

<script>
import SubSection from '@/components/content/education/courses/CourseBookSection.vue'

export default {
  name: 'CourseBookSubSection',
  components: { SubSection },
  beforeRouteUpdate(to, from, next) {
    if (this.$refs['sub-section']) {
      this.$refs['sub-section'].onBeforeRouteUpdate(to, from, next)
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$refs['sub-section']) {
      this.$refs['sub-section'].onBeforeRouteLeave(to, from, next)
    }
  }
}
</script>

<style scoped>

</style>
